import { FeeCurrency } from '../CommonInterfaces';

export const getCurrencySymbol = (feeCurrency: FeeCurrency): string => {
  if (feeCurrency === FeeCurrency.GBP) {
    return '£';
  }

  return '$';
};

export const getCurrencyHintText = (feeCurrency?: FeeCurrency): string => {
  const symbol = feeCurrency ? getCurrencySymbol(feeCurrency) : '$';
  return `${symbol}X.XX`;
};
